module.exports = __webpack_public_path__ + "static/media/KAMUPS_pallana.3f97a7bc.jpeg";